import React, { useMemo } from 'react'
import block from 'bem-cn'

import Loader from 'components/Loader/Loader'

import { getCurrentAspectRatio } from '../data/getAspectRatio'

import './SliderPlug.scss'

const b = block('slider-plug')

interface ISliderPlugProps {
  isMobileOrTablet: boolean
  pathname: string
}

export const SliderPlug: React.FC<ISliderPlugProps> = ({ isMobileOrTablet, pathname }) => {
  const aspectRatio = useMemo(() => getCurrentAspectRatio(isMobileOrTablet, pathname), [isMobileOrTablet, pathname])

  return (
    <div className={b()} style={{ paddingBottom: `${100 / aspectRatio}%` }}>
      <Loader loading />
    </div>
  )
}
